import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {ButtonModule} from '../button/button.module'
import {RatingModule} from '../rating/rating.module'
import {PipesModule} from '../../shared/pipes/pipes.module'
import {NgOptimizedImage} from '@angular/common'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {faCaretDown} from '@fortawesome/pro-solid-svg-icons/faCaretDown'
import {faLocationDot} from '@fortawesome/pro-solid-svg-icons/faLocationDot'
import {faPlus} from '@fortawesome/pro-solid-svg-icons/faPlus'
import {DropdownModule} from '../dropdown/dropdown.module'
import {CompanyInitialsPipe} from '../../shared/pipes/company-initials-pipe.pipe'
import {ProProfileLogoAltTextPipe} from '../pipes/pro-profile-logo-alt-text.pipe'
import {MaxPipe} from '../../shared/pipes/max.pipe'
import {ProTopPartnerBannerComponent} from '../../shared/components/pro-top-partner-banner/pro-top-partner-banner.component'
import {I18nDirective} from '../i18n/i18n.directive'
import {ChipComponent} from '../chip/chip.component'

export interface ProfileIntro {
  companyName: string
  industries: string[]
  locations: {place: {locality: string; postalCode: number}}[]
  profile: {
    logoImage?: {
      url?: string
    }
    yearsAsTopPartner?: number[]
  }
  recommendingAgency?: string
  assignmentRegions: {label: string}[]
}
@Component({
  selector: 'cft-profile-introduction',
  templateUrl: './profile-introduction.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ButtonModule,
    RatingModule,
    PipesModule,
    FontAwesomeModule,
    NgOptimizedImage,
    DropdownModule,
    CompanyInitialsPipe,
    ProProfileLogoAltTextPipe,
    MaxPipe,
    ProTopPartnerBannerComponent,
    I18nDirective,
    ChipComponent,
  ],
})
export class ProfileIntroductionComponent {
  readonly industryPreviewLength = 3

  readonly faLocation = faLocationDot
  readonly faPlus = faPlus
  readonly faCarretDown = faCaretDown

  @Input({required: true}) pro!: ProfileIntro
  @Input() showRecommendedBy = false

  get mainPostalCodeAndLocality(): string | undefined {
    const location = this.pro.locations[0].place
    return `${location?.postalCode} ${location?.locality}`
  }

  firstAssigmentRegion(assignmentRegion: {label: string}[]): string {
    return assignmentRegion[0].label
  }

  get hasMultipleLocations(): boolean {
    return this.pro.locations.length > 1
  }

  get hasMultipleAssigmentRegions(): boolean {
    return this.pro.assignmentRegions.length > 1
  }

  get previewIndustries() {
    return this.pro.industries.slice(0, this.industryPreviewLength)
  }
}
